import React from "react";
import platform from "platform";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { SAFARI_SHARE, MENU_ICON, STAR_ICON } from './bookmarkImages.js';
import MENU_ICON_NEW from "./chrome_menu.svg";

const BookmarkPopup = (props) => {

    const { t } = props


    const handleAddBookmark = () => {

        if (window.external && window.external.AddFavourite) {
            window.external.AddFavourite(window.location.href, window.document.title); // eslint-disable-line new-cap
        }
    }

    const renderDesktop = () => {
        const addToBookmarkLink = (props) => 
            <a onClick={handleAddBookmark} {...props}>Click here to add this page to your bookmarks</a>

        let commandButton = 'Ctrl';
        if (platform.os.family && platform.os.family === 'OS X') {
            commandButton = 'Command (⌘)';
        }

        let bookmarkLink = null;
        if (platform.name && platform.name.includes('Firefox')) {
            const props = { rel: 'sidebar'};
            bookmarkLink = addToBookmarkLink(props);
        }
        if (window.external && window.external.AddFavourite) {
            bookmarkLink = addToBookmarkLink();
        }

        return (
            <>
                {bookmarkLink || <span><strong>Tip:</strong> Press <strong>{commandButton} + D</strong> to add this page to your bookmarks.</span>}
            </>
        );
    }

    const renderMobile = (content) => {
        let newContent = content;

        if (platform.name && platform.manufacturer && platform.name.includes('Safari') && platform.manufacturer.includes('Apple')) {
            newContent = (
                <p><strong>Tip:</strong> Press <img style={{width:"20px", borderRadius:"5px"}} src={SAFARI_SHARE} /> then <strong>Add to Home Screen</strong> to add this page to your home screen.</p>
            );
        } else if (platform.name && (platform.name.includes('Chrome') || platform.name.includes('Firefox'))) {
            newContent = (
                <p><strong style={{paddingRight:"4px"}}>Tip:</strong> Press <img style={{width:"3px", marginLeft:"5px", marginRight:"5px"}} src={MENU_ICON_NEW} /> then <img style={{width:"20px", marginLeft:"4px", marginRight:"4px"}} src={STAR_ICON} /> to add this page to your bookmarks.</p>
            );
        }

        return (
            <>
                {newContent}
            </>
        );
    }

    const renderTablet = content => {
        let newContent = content;

        if (platform.name && (platform.name.includes('Chrome') || platform.name.includes('Firefox'))) {
            newContent = (
                <div><strong style={{paddingRight:"4px"}}>Tip:</strong><p>Press <img style={{width:"20px"}} src={STAR_ICON} /> next to the address bar to add this page to your bookmarks.</p></div>
            );
        }

        return (
            <>
                {newContent}
            </>
        );
    }



    return (
        <>
            <section className="notice float-notice">
                <div className="notice-text">
                    {(() => {
                        let content = <p>Remember to add this page to your bookmarks!</p>;
                        if (/Mobile/i.test(navigator.userAgent)) {
                            return renderMobile(content);
                        } else if (/Android/i.test(navigator.userAgent)) {
                            return renderTablet(content);
                        } else {
                            return renderDesktop();
                        }
                    })()}
                </div>
                <div class="notice-icon" onClick={() => props.closeBookMark()}><i class="fas fa-times-circle"></i></div>
            </section>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        redirectInfo: state.store2.redirectInfo,
    }
}


export default connect(mapStateToProps, {})(withTranslation('translations')(BookmarkPopup));